module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg6.cb01787c.png";